import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const AlignLeft: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['line', { x1: '21', x2: '3', y1: '6', y2: '6' }],
    ['line', { x1: '15', x2: '3', y1: '12', y2: '12' }],
    ['line', { x1: '17', x2: '3', y1: '18', y2: '18' }],
  ],
];

export default AlignLeft;
